import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Category } from '../../../../interfaces/tell_me/category.types';
import { deleteCategory } from '../../../../api/api';
import { useDispatch } from 'react-redux';
import { getDataSetToRedux } from '../../../../utility/getAffirmationAndCategory';

interface Props {
    handleClose: VoidFunction,
    category: Category,
    open: boolean,
}

export default function CategoryDeleteDialog(props: Props) {

    const dispatch = useDispatch();
    const [categoryId, setCategoryId] = useState(props.category.id);

    useEffect(() => {
        setCategoryId(props.category.id);
    }, [props.category])

    const handleClose = () => {
        props.handleClose();
    }

    const handleDelete = async () => {
        console.log("DeLETE");
        const response = await deleteCategory(categoryId);
        await getDataSetToRedux(dispatch);
        
        if(response.success){
            alert("DELETED");
        }else{
            alert("Error ");
            console.log(response.message);
        }

        props.handleClose();
    }

    return (
        <Dialog open={props.open} onClose={handleClose} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">Delete Category</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    After deletion, you will not be able to restore {props.category.name}.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Cancel
                </Button>
                <Button onClick={handleDelete} color="primary">
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    )
}